import Vue from 'vue'
import { ActionTree, MutationTree } from 'vuex'
import { RootState } from '@/store/types'

import { Show } from '@/store/modules/lib'


export interface State {
  eventId: string | null
  shows: Show[]
  loadStatus: string
}

const defaultState: State = {
  eventId: null,
  shows: [],
  loadStatus: ''
};

const getters = {
  shows: (state: State) => state.shows
}

const mutations: MutationTree<State> = {
  loading (state: State) {
    state.loadStatus = 'loading'
    state.eventId = null
    state.shows = []
  },
  setup (state: State, { eventId, shows } : any) {
    state.loadStatus = 'success'
    state.eventId = eventId
    state.shows = shows
  },
  error (state: State) {
    state.loadStatus = 'error'
    state.eventId = null
    state.shows = []
  },
  clear (state: State) {
    state.loadStatus = 'clear'
    state.eventId = null
    state.shows = []
  }
}

const actions: ActionTree<State, RootState> = {
  load({ commit }, { eventId }) {

    return new Promise((resolve, reject) => {
      commit('loading')

      Vue.axios({
        url: '/query',
        method: 'POST',
        data: `
          {
            "query": "query{Shows(_event:\\"${eventId}\\"){count values{begin code color thematics { id title } description end _event _id logo title}}}",
            "variables": {}
          }
        `
      })
        .then((resp: any) => {
          if (resp.data.status === 'ok') {
            commit('setup', { eventId, shows: resp.data.data.Shows.values })
            resolve(resp)
          } else {
            reject()
          }
        })
        .catch((err: any) => {
          commit('error')
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
